import { createFileRoute } from '@tanstack/react-router'
import { LicenseUtilizationDashboard } from '../../../features/admin/LicenseUtilizationDashboard'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/license')({
  component: AdminLicenseRoute,
})

/* ───── Route Component ───── */

function AdminLicenseRoute() {
  return <LicenseUtilizationDashboard />
}
